// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultItem__group-container-c27ffe {
  display: flex;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 16px;
  padding-inline-end: 20px;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
}

.SearchResultItem__group-container-c27ffe:hover {
  background-color: var(--base-20);
}

.SearchResultItem__group-container-c27ffe.SearchResultItem__active-f2a278 {
  background-color: var(--base-10);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResultItem/SearchResultItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".group-container {\n  display: flex;\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 16px;\n  padding-inline-end: 20px;\n  box-sizing: border-box;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.group-container:hover {\n  background-color: var(--base-20);\n}\n\n.group-container.active {\n  background-color: var(--base-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group-container": `SearchResultItem__group-container-c27ffe`,
	"groupContainer": `SearchResultItem__group-container-c27ffe`,
	"active": `SearchResultItem__active-f2a278`
};
module.exports = ___CSS_LOADER_EXPORT___;
